/* eslint-disable no-unused-vars */
import { useMemo } from 'react';

import TaskDetailComponent from '@components/task-detail-component';
import Icon from '@components/icon-component';

import { PERMISSIONS } from 'permissions/constants';
import { decodeToken } from '@utilities/authentication';

import style from './style.module.scss';

const StructureSite = ({
  setAllTask,
  setWorkOrder,
  allWorkOrderForStructure,
  allDoneWorkOrder,
  tasks,
  allDoneTasks,
  isOverDue,
  isWorkOrderOverDue,
  allDoneChecks,
  allChecks,
  isCheckOverDue,
  setChecks,
  newWorkRequestList,
  setWorkRequest,
  allOnDemandRecordCount,
  newWorkOrderList,
  newChecksList,
  setInspections,
  allInspectionForSite,
  allDoneInspection,
  isInspectionOverDue,
  newInspectionList = [],
  setNewOrEditAssets,
  allEditEquipmentAssets = [],
  card: Card = () => <></>
}) => {
  const { iconName, taskName } = useMemo(() => {
    let showAllTasksAndRecordsTab = false,
      showAllTasksTab = false,
      showAllRecordTab = false,
      iconName = '',
      taskName = '';

    (showAllTasksAndRecordsTab = allOnDemandRecordCount > 0 && tasks?.length > 0 ? true : false),
      (showAllTasksTab = allOnDemandRecordCount === 0 && tasks?.length > 0 ? true : false),
      (showAllRecordTab = allOnDemandRecordCount > 0 && tasks?.length === 0 ? true : false);

    if (showAllRecordTab) iconName = 'on-demand-indicator-circle';
    else if (showAllTasksTab) {
      iconName =
        allDoneTasks?.length === tasks?.length
          ? 'all-task-completed-bag'
          : allDoneTasks?.length > 0 && tasks?.length > allDoneTasks?.length
          ? 'some-task-completed-bag'
          : 'no-task-completed-bag';
    } else if (showAllTasksAndRecordsTab) {
      iconName =
        allDoneTasks?.length === tasks?.length
          ? 'task-record-all-task-completed'
          : allDoneTasks?.length > 0 && tasks?.length > allDoneTasks?.length
          ? 'task-record-some-task-completed'
          : 'task-record-no-task-completed';
    }

    taskName = showAllTasksAndRecordsTab
      ? 'All tasks + records'
      : showAllTasksTab
      ? 'All tasks'
      : showAllRecordTab
      ? 'All records'
      : '';

    return {
      iconName,
      taskName
    };
  }, [allOnDemandRecordCount, tasks]);

  const allTasksAndRecordsChips = {
    img: <Icon name={iconName} />,
    taskName: taskName,
    btnText: `${allDoneTasks.length}/${tasks.length}`,
    click: () => setAllTask(true),
    allDoneTasks: allDoneTasks,
    allTasksForSite: tasks,
    isOverDue: isOverDue,
    dot: !!isOverDue && allDoneTasks?.length !== tasks?.length,
    recordCount: allOnDemandRecordCount,
    notShowInProgressCount: allDoneTasks?.length > 0 || tasks.length > 0 ? false : true
  };

  const permissions = useMemo(() => {
    return decodeToken()?.permissions || {};
  }, []);

  const taskDetail = [
    ...(permissions[PERMISSIONS.MOBILE_ASSIGNED_INSPECTIONS] && allInspectionForSite?.length
      ? [
          {
            img: <Icon name={'ins'} />,
            taskName: 'Inspections',
            btnText: `${allDoneInspection.length}/${allInspectionForSite.length}`,
            click: () => setInspections(true),
            allDoneTasks: allDoneInspection,
            allTasksForSite: allInspectionForSite,
            isOverDue: isInspectionOverDue,
            dot: !!isOverDue && allDoneInspection?.length !== allInspectionForSite?.length,
            recordCount: newInspectionList?.length || 0,
            notShowInProgressCount:
              allDoneInspection?.length > 0 || allInspectionForSite.length > 0 ? false : true
          }
        ]
      : []),

    ...(permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS] &&
    (allWorkOrderForStructure?.length > 0 || newWorkOrderList?.length > 0)
      ? [
          {
            img: <Icon name={'work-orders'} />,
            taskName: 'Work orders',
            btnText: `${allDoneWorkOrder.length}/${allWorkOrderForStructure.length}`,
            click: () => setWorkOrder(true),
            allDoneTasks: allDoneWorkOrder,
            allTasksForStructure: allWorkOrderForStructure,
            isOverDue: isWorkOrderOverDue,
            dot: !!isOverDue && allDoneWorkOrder?.length !== allWorkOrderForStructure?.length,
            recordCount: newWorkOrderList?.length || 0,
            notShowInProgressCount:
              allDoneWorkOrder?.length > 0 || allWorkOrderForStructure.length > 0 ? false : true
          }
        ]
      : []),

    ...(permissions[PERMISSIONS.MOBILE_ASSIGNED_CHECKS] &&
    (allChecks?.length || newChecksList?.length > 0)
      ? [
          {
            img: <Icon name={'check-grey'} />,
            taskName: 'Checks',
            btnText: `${allDoneChecks.length}/${allChecks.length}`,
            click: () => setChecks(true),
            allDoneTasks: allDoneChecks,
            allTasksForStructure: allChecks,
            isOverDue: isCheckOverDue,
            dot: !!isOverDue && allDoneChecks?.length !== allChecks?.length,
            recordCount: newChecksList?.length || 0,
            notShowInProgressCount: allDoneChecks?.length > 0 || allChecks.length > 0 ? false : true
          }
        ]
      : []),

    ...(permissions[PERMISSIONS.MOBILE_ASSIGNED_WORKORDERS] && newWorkRequestList?.length
      ? [
          {
            img: <Icon name={'work-orders'} />,
            taskName: 'Work requests',
            btnText: `${newWorkRequestList?.length}`,
            click: () => setWorkRequest(true),
            allDoneTasks: [],
            allTasksForSite: newWorkRequestList,
            isOverDue: false,
            dot: false,
            notShowInProgressCount: false
          }
        ]
      : []),

    ...((permissions[PERMISSIONS.EQUIPMENT_EDIT] || permissions[PERMISSIONS.EQUIPMENT_CREATE]) &&
    allEditEquipmentAssets?.length
      ? [
          {
            img: <Icon name={'new-or-edit-assets-icon'} />,
            taskName: 'New or edited assets',
            btnText: `${allEditEquipmentAssets?.length}`,
            click: () => setNewOrEditAssets(true),
            allDoneTasks: [],
            allTasksForSite: allEditEquipmentAssets,
            isOverDue: false,
            dot: false,
            notShowInProgressCount: false
          }
        ]
      : [])
  ];

  return (
    <div id="tasks-info-tab" style={{ overflow: 'auto' }} className={style.testing}>
      {Card ? <Card /> : <></>}

      <div className={style.allTasksAndRecordsContainer}>
        <TaskDetailComponent
          task={allTasksAndRecordsChips.taskName}
          onClick={allTasksAndRecordsChips.click}
          {...allTasksAndRecordsChips}
        />

        <div className={style.byType}>
          <p>By type</p>
        </div>
      </div>
      <div className={style.addMarginBottom}>
        {(tasks?.length || allOnDemandRecordCount > 0) &&
          taskDetail?.map((ele, index) => {
            return ele.taskName === 'All Tasks' &&
              taskDetail?.filter((a) => a.allTasksForStructure.length > 0).length === 2 ? (
              <></>
            ) : (
              <TaskDetailComponent
                key={index}
                task={ele.taskName}
                onClick={ele.click}
                isOverDue={isOverDue}
                allTasksForSite={ele.allTasksForStructure}
                showBorderOnTop={!index}
                {...ele}
              />
            );
          })}
      </div>
    </div>
  );
};

export default StructureSite;
